export default class ScrollCalc {
  // containerWidth, scrollWidth, contentWidthがそろったらtrue
  private prepared: boolean = false;
  // NativeValue: windowWidth >
  public containerWidth: number;
  public scrollWidth: number;
  // NativeValue: content >
  public contentWidth: number;
  // DinamicValue: windowWidth & contentWidth >
  public tabWidth: number = 0;
  public range: number = 0;
  public scrollable: number = 0;
  // DinamicValue: windowWidth & contentWidth & scrollPosition >
  public contentPosition: number = 0;
  // DinamicValue: windowWidth & contentWidth & contentPosition >
  public scrollPosition: number = 0;

  public updateContainerWidth(w:number):void{
    this.containerWidth = w;
  }
  public updateScrollWidth(w:number){
    this.scrollWidth = w;
  }
  public updateContentWidth(w:number){
    this.contentWidth = w;
  }
  public updateContentPosition(n:number){
    this.calcScrollPositionByContentPosition(n);
  }
  public updateScrollPosition(n:number){
    this.calcContentPositionByScrollPosition(n);
  }
  public updateScaleIfPrepared(){
    if(!this.isPreparedNatives()){ return; }
    this.updateScale();
  }
  public updateScale(){
    this.calcTabWidth();
    this.calcRange();
    this.calcScrollable();
  }
  public isPreparedNatives(){
    if(this.prepared){ return true; }
    if(this.containerWidth == null){ return false; }
    if(this.scrollWidth == null) { return false; }
    if(this.contentWidth == null){ return false; }
    this.prepared = true;
    return true;
  }
  public calcTabWidth(){
    // コンテントがわくよりも小さい場合はスクロールが必要ないので
    if(this.containerWidth >= this.contentWidth){
      this.tabWidth = 0
    }else{
      this.tabWidth = this.containerWidth / this.contentWidth * this.scrollWidth;
    }
  }
  // コンテントの位置からスクロールの位置を決める
  public calcScrollPositionByContentPosition(contentPosition:number){
    if(this.range < 0) {
      this.contentPosition = Math.max(Math.min(this.range, contentPosition), 0);
      // スクロールタブ可動範囲はスクロール範囲からタブの幅を引いたもの
      let scrollable = this.scrollWidth - this.tabWidth;
      // コンテントの可動範囲でコンテント位置を割れば0~1の割合がでるので、
      // それをにスクロールタブ可動範囲をかければ位置がでる。
      this.scrollPosition = contentPosition / this.range * this.scrollable;
    } else {
      this.contentPosition = 0;
      this.scrollPosition = 0;
    }
  }
  public calcContentPositionByScrollPosition(scrollPosition: number){
    if(this.range < 0){
      scrollPosition = Math.min(Math.max(scrollPosition, 0), this.scrollable);
      this.scrollPosition = scrollPosition;
      // スクロール可動範囲が0以下であればポジションも0
      if(this.scrollable <= 0){
        this.contentPosition = 0;
      } else {
        // スクロールの可動範囲でスクロールの位置を割れば0~1の割合がでるので、
        // それにコンテントの可動範囲をかければ位置がでる。
        this.contentPosition = scrollPosition / this.scrollable * this.range;
      }
    } else {
      this.contentPosition = 0;
      this.scrollPosition = 0;
    }
  }

  // コンテント稼働範囲rangeは常に0~マイナスの値
  public calcRange(){
    this.range = this.containerWidth - this.contentWidth;
    // はみ出した分（マイナスの値）がなければスクロールが必要ないのでポジションは0
    if(this.range > 0){ this.range = 0; }
  }

  // スクロール可動範囲は常に0~プラスの値
  public calcScrollable(){
    this.scrollable = 0;
    // タブ幅自体がなければスクロールタブ可動範囲は0、幅があれば計算する
    if(this.tabWidth > 0){
      // スクロールタブ可動範囲はスクロール範囲からタブの幅を引いたもの
      this.scrollable = this.scrollWidth - this.tabWidth;
    }
  }
}
